export const setInTransition = (innerRefScrollHeight: number) =>
  innerRefScrollHeight !== 0;
